import { render, staticRenderFns } from "./ResumeSimulatorPage.vue?vue&type=template&id=9daa918e&"
import script from "./ResumeSimulatorPage.vue?vue&type=script&lang=js&"
export * from "./ResumeSimulatorPage.vue?vue&type=script&lang=js&"
import style0 from "./ResumeSimulatorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports